import { createContext, useContext } from 'react';

import UserStore from './userStore';
import FacilityStore from './facilityStore';
import ApiErrorStore from './apiErrorStore';
import BookingStore from './bookingStore';

interface Store {
    userStore: UserStore;
    facilityStore: FacilityStore;
    apiErrorStore: ApiErrorStore;
    bookingStore: BookingStore;
}

export const Store: Store = {
    userStore: new UserStore(),
    facilityStore: new FacilityStore(),
    apiErrorStore: new ApiErrorStore(),
    bookingStore: new BookingStore(),
}

export const StoreContext = createContext(Store);

// react hook
export function useStore() {
    return useContext(StoreContext);
}